module.exports = __webpack_public_path__ + "static/media/entrance.2036d71c.jpg";